function handlePermission(permissions_list, permission) {
  const arr = permissions_list || [];
  if (arr?.includes(permission)) {
    return true;
  }
  return false;
}

export default handlePermission;